import React from "react";
import styled from "styled-components";
import PaymentLogs from "./components/PaymentLogs";
import { DetailsLayout } from "components/akapBigas/detailsLayout";
import downloadIcon from "assets/akap/download-icon.svg";
import { downloadPaymentLogs } from "services/merchant.service";

const Container = styled.div``;

const LogsSection = styled.div`
  padding: 1rem;
`;

const RightButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: right;
  justify-content: right;
  border-radius: 50%;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  img {
    width: 30px;
    height: 30px;
    filter: brightness(0) invert(1);
  }
`;

const DownloadIcon = styled.img`
  width: 30px;
  height: 30px;
  filter: brightness(0) invert(1);
`;
const Payment = () => {

  const user = JSON.parse(localStorage.getItem("qrUser"));

  const handleDownload = () => {
    downloadPaymentLogs(user.id);
  };

  return (
    <Container>
      <DetailsLayout
        title="My Payments"
        topRight={
          <RightButton onClick={handleDownload}>
            <DownloadIcon src={downloadIcon} alt="download" />
          </RightButton>
        }
      >
        <LogsSection>
          <PaymentLogs />
        </LogsSection>
      </DetailsLayout>
    </Container>
  );
};

export default Payment;
